/**
 * Helper function to get the correct asset path (images, videos, etc.) for development, staging, and production
 * @param {string} path - Asset path starting with /images/, /videos/, etc.
 * @returns {string} - Corrected path based on build mode
 */
export const getImagePath = (path) => {
  // Check if we're in staging mode
  const isStaging = import.meta.env.MODE === 'staging';
  
  if (isStaging) {
    // For staging, use Django static path format
    // Convert /images/... to /static/thevbcgroup/images/...
    if (path.startsWith('/images/')) {
      return path.replace('/images/', '/static/thevbcgroup/images/');
    }
    // Convert /videos/... to /static/thevbcgroup/videos/...
    if (path.startsWith('/videos/')) {
      return path.replace('/videos/', '/static/thevbcgroup/videos/');
    }
    // If path already has the static prefix, return as-is
    if (path.startsWith('/static/thevbcgroup/')) {
      return path;
    }
    // Otherwise, assume it needs the full path (default to images)
    return `/static/thevbcgroup/images/${path.replace(/^\//, '')}`;
  }
  
  // For development and production, use standard paths
  // Paths starting with / are already correct for public folder assets
  return path;
};
